module.exports = __webpack_public_path__ + "static/media/cms.b339d6ff.png";